// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu {\n  background-color: black;\n  position: fixed;\n  top: 0%;\n  height: 5%;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  z-index: 101;\n\n}\n.menu h4 {\n  color: white;\n  margin: 10px;\n  margin-left: 15px;\n  margin-right: 15px;\n  cursor: pointer;\n}\n\n@media only screen and (max-height: 500px) {\n  .menu {\n    height: 10%;\n  }\n  .content {\n    height: 92% !important;\n  }\n  .reload {\n    top: 15%;\n  }\n}", ""]);
// Exports
module.exports = exports;
